/**
 * AudioLevelIndicator Component
 * Visual feedback for microphone input level.
 */

import type { AudioLevelIndicatorProps } from "../../types/voice";

export function AudioLevelIndicator({
  level,
  isActive,
  className = "",
}: AudioLevelIndicatorProps) {
  if (!isActive) return null;

  // Scale level for better visual feedback (0-1 input, amplified for display)
  const displayLevel = Math.min(level * 3, 1);

  return (
    <div className={`w-full ${className}`}>
      <div className="h-1.5 bg-dark-border rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-accent-green via-accent-yellow to-accent-red transition-all duration-75"
          style={{ width: `${displayLevel * 100}%` }}
        />
      </div>
    </div>
  );
}
